import { render, staticRenderFns } from "./list-customers.vue?vue&type=template&id=77a1687a"
import script from "./list-customers.vue?vue&type=script&lang=js"
export * from "./list-customers.vue?vue&type=script&lang=js"
import style0 from "./list-customers.vue?vue&type=style&index=0&id=77a1687a&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports